import Vue from 'vue';
import Router from 'vue-router';
import Main from './router/main'
import Other from './router/other'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/main/online'
    },
    {
      path: '/404',
      component: () => import('./views/404.vue')
    },
    {
      path: '/main',
      component: () => import('./components/common/Home.vue'),
      meta: {title: '系统首页'},
      children: [
        ...Main
      ]
    },
    ...Other,
    {
      path: '/visualization',
      component: () => import('./views/Visualization.vue'),
      meta: {title: '大屏'}
    },
    {
      path: '/login',
      meta: {title: '登录', needLogin: false},
      component: () => import('./views/Login.vue')
    },
    /**
     * 单点登录
     * @query.type
     * @query.from
     * @query.token
     */
    {
      path: '/oauth2',
      meta: {title: '单点登录', needLogin: false},
      component: () => import('./views/Oauth2.vue')
    },
    {
      path: '*',
      redirect: '/404'
    },
  ]
})
